<section class="p-d-flex p-flex-column">
  <div class="revenue">
    <!-- TODO: Fix the currency; make it dynamic -->
    <ng-container *ngIf="todaysRevenue$ | async as todaysRevenue">

      <!-- Revenue -->
      <span class="p-d-flex p-jc-between">
        <span class="amount">
          Revenue: {{ todaysRevenue.total | freyaCurrency: todaysRevenue.currency }}
        </span>
        <a
          [routerLink]="['/reports', 'dynamic', 'new']"
          [queryParams]="revenueReportQueryParams"
        >
          <i
            class="open-report pi pi-file-check"
            pTooltip="Open revenue report"
          ></i>
        </a>
      </span>

      <!-- Rev/Labor Hr — gated by dispatch.viewRevenuePerHour permission -->
      <ng-container *ngIf="canViewRevenuePerHour$ | async">
        <span class="amount secondary-data" *ngIf="todaysRevenue.revenuePerLaborHour !== null && todaysRevenue.revenuePerLaborHour !== undefined">
          Rev/Labor Hr: {{ todaysRevenue.revenuePerLaborHour | freyaCurrency: todaysRevenue.currency }}
          <span class="percentage" *ngIf="todaysRevenue.totalLaborHours !== null && todaysRevenue.totalLaborHours !== undefined">
            ({{ todaysRevenue.totalLaborHours | number:'1.1-1' }}h)
          </span>
        </span>
      </ng-container>

      <!-- Labor cost — gated by dispatch.viewLaborCosts permission -->
      <ng-container *ngIf="canViewLaborCosts$ | async">
        <span
          class="amount secondary-data"
          *ngIf="todaysRevenue.totalLaborCost !== null && todaysRevenue.totalLaborCost !== undefined"
        >
          Cost: {{ todaysRevenue.totalLaborCost | freyaCurrency: todaysRevenue.currency }}
          <span class="percentage">({{ todaysRevenue.laborCostPercentage }}%)</span>
        </span>
      </ng-container>

    </ng-container>
  </div>
  <div class="p-d-flex p-jc-between p-ai-center p-mb-2">
    <p-selectButton
      [options]="viewOptions"
      [(ngModel)]="activeView"
      optionLabel="label"
      optionValue="value"
    ></p-selectButton>

    <div *ngIf="activeView === 'crew'">
      <p-contextMenu
        #cm
        [model]="crewContextMenuItems"
        appendTo="body"
      ></p-contextMenu>
      <p-menu
        #menu
        [model]="crewMenuOptions"
        [popup]="true"
        appendTo="body"
      ></p-menu>
      <p-button
        icon="pi pi-ellipsis-v"
        [text]="true"
        (onClick)="menu.toggle($event)"
      />
      <input
        #csvUpload
        type="file"
        (change)="onCsvUpload($event)"
        accept=".csv"
        hidden
      >
    </div>
  </div>

  <ng-container *ngIf="activeView === 'crew'">
    <form
      class="p-d-flex p-jc-start p-ai-center filters p-flex-wrap"
      style="gap: 0.5rem"
      [formGroup]="filterCrewForm"
    >
      <div style="flex: 1 1 120px">
        <p-dropdown
          formControlName="capabilities"
          [options]="capabilitiesOptions"
          optionLabel="label"
          optionValue="label"
          [style]="{ width: '100%' }"
        >
          <ng-template
            pTemplate="selectedItem"
            let-selectedOption
          >
            <ng-container *ngTemplateOutlet="
              dropdownItemTemplate;
              context: { $implicit: selectedOption, labelPrefix: 'Capability:' }
            "></ng-container>
          </ng-template>
          <ng-template
            pTemplate="item"
            let-item
          >
            <ng-container *ngTemplateOutlet="
              dropdownItemTemplate;
              context: { $implicit: item, labelPrefix: '' }
            "></ng-container>
          </ng-template>
        </p-dropdown>
      </div>

      <div style="flex: 1 1 120px">
        <p-dropdown
          formControlName="status"
          [options]="statusOptions"
          optionLabel="label"
          optionValue="label"
          [style]="{ width: '100%' }"
        >
          <ng-template
            pTemplate="selectedItem"
            let-selectedOption
          >
            <ng-container *ngTemplateOutlet="
              dropdownItemTemplate;
              context: { $implicit: selectedOption, labelPrefix: 'Status:' }
            "></ng-container>
          </ng-template>
          <ng-template
            pTemplate="item"
            let-item
          >
            <ng-container *ngTemplateOutlet="
              dropdownItemTemplate;
              context: { $implicit: item, labelPrefix: '' }
            "></ng-container>
          </ng-template>
        </p-dropdown>
      </div>

      <div style="flex: 1 1 120px">
        <p-dropdown
          formControlName="sort"
          [options]="sortOptions"
          optionLabel="label"
          optionValue="label"
          [style]="{ width: '100%' }"
        >
          <ng-template
            pTemplate="selectedItem"
            let-selectedOption
          >
            <ng-container *ngTemplateOutlet="
              dropdownItemTemplate;
              context: { $implicit: selectedOption, labelPrefix: 'Sort:' }
            "></ng-container>
          </ng-template>
          <ng-template
            pTemplate="item"
            let-item
          >
            <ng-container *ngTemplateOutlet="
              dropdownItemTemplate;
              context: { $implicit: item, labelPrefix: '' }
            "></ng-container>
          </ng-template>
        </p-dropdown>
      </div>
    </form>

    <div class="search-bar">
      <p-iconField iconPosition="left">
        <p-inputIcon styleClass="pi pi-search" />
        <input
          type="text"
          pInputText
          placeholder="Search crew"
          [formControl]="filterCrewForm.get('userSearch')"
        />
      </p-iconField>
    </div>
    <div class="p-d-flex p-flex-column faded-border todaysCrew">
      <ng-container *ngIf="{
        usersLoaded: usersLoaded$ | async,
        filteredPotentialCrew: filteredPotentialCrew$ | async,
      } as state">
        <ng-container *ngIf="state.usersLoaded; else usersLoading">
          <div
            class="p-d-flex p-flex-column crew-list"
            cdkDropList
            (cdkDropListDropped)="dropCrew($event)"
            *ngIf="state.filteredPotentialCrew?.length; else noUsersFound"
          >
            <div
              *ngFor="let user of state.filteredPotentialCrew"
              class="crew-chip-wrapper"
              cdkDrag
              [cdkDragData]="{ attendee: user }"
              [ngStyle]="{
              order: user.user.capabilities?.includes('CrewLead') ? 1 : 2,
            }"
            >
              <app-dispatch-chip
                [name]="user?.name"
                [eventsCount]="user?.eventsCount"
                [revenue]="user?.revenue"
                [rateHourly]="(canViewLaborCosts$ | async) ? user.user.rateHourly : null"
                [tooltipText]="(canViewLaborCosts$ | async) ? user.ratingTooltipText : ''"
                (click)="editUser(user)"
                (edit)="editUser(user)"
                [showStar]="user.user.capabilities?.includes('CrewLead')"
                [isDriver]="user.isDriver"
                [isUnavailable]="user.isUnavailable"
                [isBookedOff]="user.isBookedOff"
                [isAssigned]="user.isAssigned"
                panelType="left"
                (contextmenu)="onRightClick($event, user)"
              ></app-dispatch-chip>
            </div>
          </div>
        </ng-container>
      </ng-container>
      <ng-template #usersLoading> Loading Users </ng-template>
      <ng-template #noUsersFound>
        <div class="p-d-flex p-flex-column p-jc-center p-ai-center no-users-found">
          <p-button
            *ngIf="filterCrewForm.value.status !== 'All' || filterCrewForm.value.capabilities !== 'All'"
            [outlined]="true"
            label="Expand Search"
            icon="pi pi-filter-slash"
            (onClick)="expandSearch()"
          ></p-button>

          <p-button
            *ngIf="filterCrewForm.value.status === 'All' && filterCrewForm.value.capabilities === 'All'"
            [outlined]="true"
            severity="secondary"
            label="Add Crew"
            icon="pi pi-user-plus"
            (onClick)="addAvailableCrew()"
          ></p-button>
          <p>No users found</p>
        </div>
      </ng-template>
    </div>
  </ng-container>

  <ng-container *ngIf="activeView === 'trucks'">
    <div class="search-bar">
      <p-iconField iconPosition="left">
        <p-inputIcon styleClass="pi pi-search" />
        <input
          type="text"
          pInputText
          placeholder="Search trucks"
          [formControl]="filterCrewForm.get('assetSearch')"
        />
      </p-iconField>
    </div>
    <div class="p-d-flex p-flex-column faded-border todaysTrucks">
      <ng-container *ngIf="{
        assetsLoaded: assetsLoaded$ | async,
        filteredPotentialAssets: filteredPotentialAssets$ | async,
      } as state">
        <ng-container *ngIf="state.assetsLoaded; else assetsLoading">
          <div
            class="p-d-flex p-flex-column crew-list"
            cdkDropList
            *ngIf="state.filteredPotentialAssets?.length; else noAssetsFound"
          >
            <app-dispatch-chip
              cdkDrag
              [cdkDragData]="{ asset }"
              *ngFor="let asset of state.filteredPotentialAssets"
              [name]="asset?.name"
              icon="pi pi-truck"
              [eventsCount]="asset?.eventsCount"
              [revenue]="asset?.revenue"
              panelType="left"
            ></app-dispatch-chip>
          </div>
        </ng-container>
      </ng-container>
      <ng-template #assetsLoading> Loading Assets </ng-template>
      <ng-template #noAssetsFound>
        <p>No assets found</p>
      </ng-template>
    </div>
  </ng-container>
</section>

<!-- Reusable template for dropdown items -->
<ng-template
  #dropdownItemTemplate
  let-item
  let-labelPrefix="labelPrefix"
>
  <div class="flex align-items-center gap-2">
    <i
      class="pi p-mr-2"
      [ngClass]="item.icon"
    ></i>
    <div class="p-text-capitalize">{{ labelPrefix }} {{ item.label }}</div>
  </div>
</ng-template>